/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Tool } from '@/types/tool.type';

export const mapToolResponse = (data: Record<string, any>): Tool => ({
  id: data.tool_id,
  name: data.name,
  description: data.description,
  type: data.type,
  status: data.status,
  enabled: data.enabled,
  config: data.config ?? null,
  created_at: data.created_at,
  updated_at: data.updated_at,
});

export const mapToolCreateResponse = (response: Record<string, any>): Tool =>
  mapToolResponse(response.data);

export const mapToolDetailResponse = (response: Record<string, any>): Tool =>
  mapToolResponse(response.data);
